import { useGiayBaoNoSearchContext } from './search-context';
import { useGiayBaoNoImport } from './useGiayBaoNoImport';
import { useGiayBaoNoMutation } from './useGiayBaoNoMutation';
import { useGiayBaoNoTable } from './useGiayBaoNoTable';

export const useGiayBaoNoPage = () => {
  const { isExporting } = useGiayBaoNoSearchContext();
  const tableState = useGiayBaoNoTable();
  const importState = useGiayBaoNoImport({ refreshData: tableState.crud.refreshData });
  const mutationState = useGiayBaoNoMutation({
    formMode: tableState.form.formMode,
    selectedObj: tableState.selection.selectedObj,
    shouldEditWithUpdatedData: tableState.editWithUpdatedDialog.open,
    editGiayBaoNoUuid: tableState.editWithUpdatedDialog.uuid,
    addItem: tableState.crud.addItem,
    updateItem: tableState.crud.updateItem,
    deleteItem: tableState.crud.deleteItem,
    handleCloseForm: tableState.form.handleCloseForm,
    clearSelection: tableState.selection.clearSelection,
    refreshData: tableState.crud.refreshData
  });

  return {
    searchDialog: tableState.searchDialog,
    formDialog: {
      open: tableState.form.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.form.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: tableState.form.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    multipleFormDialog: tableState.multipleFormDialog,
    editWithUpdatedDialog: {
      ...tableState.editWithUpdatedDialog,
      onClose: mutationState.handleCloseEditWithUpdatedData,
      onSubmit: mutationState.handleSubmit
    },
    deleteDialog: {
      open: tableState.form.showDelete,
      onClose: tableState.form.handleCloseDelete,
      selectedObj: tableState.selection.selectedObj,
      onDelete: tableState.crud.deleteItem,
      clearSelection: tableState.selection.clearSelection
    },
    bulkDeleteDialog: {
      open: tableState.form.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleBulkDelete
    },
    importDialog: importState.importDialog,
    importErrorDialog: importState.importErrorDialog,
    table: tableState.table,
    detailTable: tableState.detailTable,
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleSearch: tableState.searchDialog.onOpen,
      handleRefresh: tableState.table.onRefresh
    },
    selection: tableState.selection
  };
};
